/**
 * WindowCinematics.js
 */

import {
    CoreEvents,
    Game,
    GameAnimatedSprite,
    GameTween,
    GameWindow,
    OptionsMenuMode,
    UiImage,
    UiText,
    KeyboardKey,
    UiElement,
    UiNineSlice
} from "pixi_core";

import {
    Cinematic,
    CinematicStep,
    CINEMATIC_AVENGERS_APPEAR_TIME,
    CINEMATIC_AVENGERS_ASSEMBLE_APPEAR_TIME,
    CINEMATIC_PANEL_APPEAR_TIME,
    CINEMATIC_PANEL_DISAPPEAR_TIME,
    CINEMATIC_TIME_PER_LETTER,
    FIRST_LEVEL,
    GameEvents,
    OPTIONS_PREFAB,
    SETTINGS_PREFAB
} from "../Constants";

export class WindowCinematics extends GameWindow {
    constructor() {
        super({
            name: "WindowCinematics"
        });

        /** @private @type {Cinematic} */
        this._currentCinematic = Cinematic.eANY;

        /** @private @type {UiImage} */
        this._imgNextText = null;

        /** @private @type {UiImage} */
        this._imgNextText2 = null;

        /** @private @type {UiElement} */
        this._introCinematic = null;

        /** @private @type {UiElement} */
        this._endCinematic = null;

        /** @private @type {UiElement} */
        this._controlsFrame = null;

        /** @private @type {UiImage} */
        this._imgPortal = null;

        /** @private @type {UiNineSlice} */
        this._imgPortalText = null;

        /** @private @type {UiText} */
        this._lblIntro1 = null;

        /** @private @type {UiImage} */
        this._imgLoki = null;

        /** @private @type {UiImage} */
        this._imgLokiText = null;

        /** @private @type {UiText} */
        this._lblIntro2 = null;

        /** @private @type {UiImage} */
        this._imgIronMan = null;

        /** @private @type {UiImage} */
        this._imgIronManText = null;

        /** @private @type {UiText} */
        this._lblIntro3 = null;

        /** @private @type {UiImage} */
        this._imgAvengers = null;

        /** @private @type {UiImage} */
        this._imgAvengersText = null;

        /** @private @type {UiText} */
        this._lblIntro4 = null;

        /** @private @type {UiText} */
        this._lblEnding = null;

        /** @private @type {UiElement} */
        this._frameBtnNextLoki = null;

        /** @private @type {UiElement} */
        this._frameBtnNextIronMan = null;

        /** @private @type {UiElement} */
        this._frameBtnNextAvengers = null;

        /** @private @type {UiElement} */
        this._frameSkipAnimation = null;

        /** @private @type {Number} */
        this._introStep = CinematicStep.eSTART;

        /** @private @type {Number} */
        this._lokiX = 0;

        /** @private @type {Number} */
        this._ironManX = 0;

        /** @private @type {Number} */
        this._avengersY = 0;

        /** @private @type {Boolean} */
        this._readyForNextStep = false;

        /** @private @type {GameTween} */
        this._animationTween = null;

        /** @private @type {GameTween} */
        this._lokiFadeTween = null;

        /** @private @type {GameTween} */
        this._ironManFadeTween = null;

        /** @private @type {GameTween} */
        this._towerFadeTween = null;

        /** @private @type {GameAnimatedSprite} */
        this._skipTimer = null;

        Game.on(GameEvents.eCINEMATIC_SET, this._onSetCinematic, this);
        Game.on(GameEvents.eCINEMATIC_SKIP, this._onSkipCinematic, this);

        Game.on(CoreEvents.eINPUT_TAP, this._onCinematicNext, this);
        Game.on(CoreEvents.eINPUT_KEY_HOLD, this._onKeyHold, this);
        Game.on(CoreEvents.eINPUT_KEY_UP, this._onKeyUp, this);
        Game.on(CoreEvents.eLOCALE_CHANGED, this._onLocaleChanged, this);
    }

    /**
     * The window is opening for the first time
     * @protected
     */
    _onFirstWindowOpening() {
        const ui = Game.ui.instantiate("Cinematics", this);

        this._introCinematic = ui.findElementByName("IntroCinematic");
        this._endCinematic = ui.findElementByName("EndingCinematic");
        this._controlsFrame = ui.findElementByName("Controls");
        this._imgNextText = ui.findElementByName("ImgNextText");
        this._imgNextText2 = ui.findElementByName("ImgNextText2");
        this._imgPortal = ui.findElementByName("ImgPortal");
        this._imgPortalText = ui.findElementByName("ImgPortalText");
        this._lblIntro1 = ui.findElementByName("LblIntro1");
        this._imgLoki = ui.findElementByName("ImgLoki");
        this._imgLokiText = ui.findElementByName("ImgLokiText");
        this._lblIntro2 = ui.findElementByName("LblIntro2");
        this._imgIronMan = ui.findElementByName("ImgIronMan");
        this._imgIronManText = ui.findElementByName("ImgIronManText");
        this._lblIntro3 = ui.findElementByName("LblIntro3");
        this._imgAvengers = ui.findElementByName("ImgAvengers");
        this._imgAvengersText = ui.findElementByName("ImgAvengersText");
        this._lblIntro4 = ui.findElementByName("LblIntro4");
        this._lblEnding = ui.findElementByName("LblEnding");
        this._frameBtnNextLoki = ui.findElementByName("FrameBtnNextLoki");
        this._frameBtnNextIronMan = ui.findElementByName("FrameBtnNextIronMan");
        this._frameBtnNextAvengers = ui.findElementByName("FrameBtnNextAvengers");
        this._frameSkipAnimation = ui.findElementByName("FrameSkipAnimation");

        this._skipTimer = new GameAnimatedSprite(null, Game.design.getGraphicData("RandomizedShooterTimer"));
        this._skipTimer.x = this._frameSkipAnimation.x;
        this._skipTimer.y = this._frameSkipAnimation.y;
        this._skipTimer.onComplete = () => {
            this._onSkipCinematic();
        };
        this._controlsFrame.uiRoot.addChild(this._skipTimer);

        this._lokiX = this._imgLoki.x;
        this._ironManX = this._imgIronMan.x;
        this._avengersY = this._imgAvengers.y;
    }

    /**
     * The window is opened for the first time
     * @protected
     */
    _onFirstWindowOpened() {}

    /**
     * The window is opening
     * @protected
     */
    _onWindowOpening() {
        // Configure the options menu for this context
        Game.windows.optionsMenu.reset({
            prefab: OPTIONS_PREFAB,
            prefabSettings: SETTINGS_PREFAB,
            mode: OptionsMenuMode.eOPTIONS,
            exclude: ["BtnHome", "BtnRestart"]
        });

        this._readyForNextStep = this._currentCinematic === Cinematic.eENDING;
        this._introStep = this._currentCinematic === Cinematic.eINTRO ? CinematicStep.eSTART : CinematicStep.eEND;
        this._introCinematic.setVisible(this._currentCinematic === Cinematic.eINTRO);
        this._endCinematic.setVisible(this._currentCinematic === Cinematic.eENDING);
        this._imgNextText.setVisible(false);
        this._imgNextText2.setVisible(false);
        this._skipTimer.visible = false;
    }

    /**
     * The window is opened
     * @protected
     */
    _onWindowOpened() {
        if (this._currentCinematic === Cinematic.eINTRO) this._startstep();
    }

    /**
     * The window is closing
     * @protected
     */
    _onWindowClosing() {}

    /**
     * The window is closed
     * @protected
     */
    _onWindowClosed() {
        this._destroyTweens();
    }

    /**
     * A locale change occurred
     * @private
     * @param {String} localeId
     * @param {Boolean} rtlLocale
     */
    _onLocaleChanged(localeId, rtlLocale) {
        if (!this.isOpened) return;

        if (!this._animationTween || (this._animationTween && !this._animationTween.isPlaying())) {
            this._lblIntro1.setText(Game.localization.getText("IDS_TXT_CINEMATIC_01"));
            this._lblIntro2.setText(Game.localization.getText("IDS_TXT_CINEMATIC_02"));
            this._lblIntro3.setText(Game.localization.getText("IDS_TXT_CINEMATIC_03"));
            this._lblIntro4.setText(Game.localization.getText("IDS_TXT_CINEMATIC_04"));
        }
    }

    /**
     * Sets the cinematic that will be played
     * @private
     * @param {Cinematic} cinematic
     */
    _onSetCinematic(cinematic) {
        this._currentCinematic = cinematic;
    }

    /**
     * Skips the cinematic and goes straight to the next gameplay/end
     * @private
     */
    _onSkipCinematic() {
        Game.audio.playSfx("IDSND_NAVIG_FORWARD");
        if (this._currentCinematic === Cinematic.eINTRO) {
            Game.fire(GameEvents.eGAME_SET_LEVEL, FIRST_LEVEL);
            Game.windows.changeContext("WindowGame");
        } else if (this._currentCinematic === Cinematic.eENDING) {
            Game.windows.changeContext("WindowLevelSelection");
        }
    }

    /**
     * Skips to the next step of the current cinematic
     * @private
     */
    _onCinematicNext() {
        if (this.isOpened && this._readyForNextStep) {
            if (this._introStep === CinematicStep.eEND) {
                this._onSkipCinematic();
            } else {
                ++this._introStep;
                this._startstep();
            }
        }
    }

    /**
     * On keyboard key hold
     * @private
     * @param {String} key
     */
    _onKeyHold(key) {
        if (!this.isOpened || Game.isPaused()) return;

        switch (key) {
            case KeyboardKey.eKEY_SPACE:
            case KeyboardKey.eKEY_ENTER:
                if (!this._skipTimer.visible) {
                    this._skipTimer.visible = true;
                    this._skipTimer.playAnimation("slowLoop", false);
                }
                break;

            default:
                break;
        }
    }

    /**
     * On keyboard key up
     * @private
     * @param {String} key
     */
    _onKeyUp(key) {
        if (!this.isOpened || Game.isPaused()) return;

        switch (key) {
            case KeyboardKey.eKEY_ARROW_UP:
            case KeyboardKey.eKEY_ARROW_DOWN:
            case KeyboardKey.eKEY_SPACE:
            case KeyboardKey.eKEY_ARROW_LEFT:
            case KeyboardKey.eKEY_ARROW_RIGHT:
            case KeyboardKey.eKEY_ENTER:
                if (this._skipTimer.visible) {
                    this._skipTimer.stop();
                    this._skipTimer.visible = false;
                } else {
                    this._onCinematicNext();
                }
                break;

            default:
                break;
        }
    }

    /**
     * Starts the next step of the current cinematic
     * @private
     */
    _startstep() {
        let textTime = 0;
        this._readyForNextStep = false;

        this._destroyTweens();

        switch (this._introStep) {
            case CinematicStep.eSTART:
                Game.audio.playSfx("IDSND_CINE_MESS_MANHATTAN");
                this._imgLoki.setOpacity(1);
                this._imgIronMan.setOpacity(1);
                this._imgPortal.setOpacity(1);
                this._imgPortalText.setVisible(true);
                this._imgLoki.setVisible(false);
                this._imgLokiText.setVisible(false);
                this._lblIntro2.setVisible(false);
                this._imgIronMan.setVisible(false);
                this._imgIronManText.setVisible(false);
                this._lblIntro3.setVisible(false);
                this._imgAvengers.setVisible(false);
                this._imgAvengersText.setVisible(false);
                ++this._introStep;
                this._readyForNextStep = true;
                this._startstep();
                break;
            case CinematicStep.eTOWER_TEXT:
                textTime = Game.localization.getText("IDS_TXT_CINEMATIC_01").length * CINEMATIC_TIME_PER_LETTER;
                this._lblIntro1.setText("");
                this._animationTween = this.createTween({ t: 0 })
                    .to({ t: 1 }, textTime)
                    .onUpdate((transition) => {
                        this._writeText(transition.t, Game.localization.getText("IDS_TXT_CINEMATIC_01"), this._lblIntro1);
                    })
                    .onComplete(() => {
                        this._readyForNextStep = true;
                        this._imgNextText2.setVisible(true);
                    })
                    .start();
                break;
            case CinematicStep.eLOKI:
                Game.audio.playSfx("IDSND_CINE_CUT_IN_01");
                this._imgNextText2.setVisible(false);
                this._imgPortalText.setVisible(false);
                this._imgLoki.setVisible(true);
                let finalLokiX = this._lokiX;
                this._imgLoki.x = Game.screen.width / 2 + this._imgLoki.width / 2;
                this._animationTween = this.createTween(this._imgLoki)
                    .to({ x: finalLokiX }, CINEMATIC_PANEL_APPEAR_TIME)
                    .easing(GameTween.Easing.QuadraticOut)
                    .onComplete(() => {
                        ++this._introStep;
                        this._startstep();
                    })
                    .start();
                this._towerFadeTween = this.createTween(this._imgPortal).to({ opacity: 0 }, CINEMATIC_PANEL_DISAPPEAR_TIME).start();
                break;
            case CinematicStep.eLOKI_TEXT:
                textTime = Game.localization.getText("IDS_TXT_CINEMATIC_02").length * CINEMATIC_TIME_PER_LETTER;
                this._lblIntro2.setText("");
                this._imgLokiText.setVisible(true);
                this._lblIntro2.setVisible(true);
                this._imgNextText.setPosition(this._frameBtnNextLoki.x, this._frameBtnNextLoki.y);
                this._animationTween = this.createTween({ t: 0 })
                    .to({ t: 1 }, textTime)
                    .onUpdate((transition) => {
                        this._writeText(transition.t, Game.localization.getText("IDS_TXT_CINEMATIC_02"), this._lblIntro2);
                    })
                    .onComplete(() => {
                        this._readyForNextStep = true;
                        this._imgNextText.setVisible(true);
                    })
                    .start();
                break;
            case CinematicStep.eIRON_MAN:
                Game.audio.playSfx("IDSND_CINE_CUT_IN_01");
                this._imgLokiText.setVisible(false);
                this._imgIronMan.setVisible(true);
                this._imgNextText.setVisible(false);
                let finalIronManX = this._ironManX;
                this._imgIronMan.x = -Game.screen.width / 2 - this._imgIronMan.width / 2;
                this._animationTween = this.createTween(this._imgIronMan)
                    .to({ x: finalIronManX }, CINEMATIC_PANEL_APPEAR_TIME)
                    .easing(GameTween.Easing.QuadraticOut)
                    .onComplete(() => {
                        ++this._introStep;
                        this._startstep();
                    })
                    .start();
                break;
            case CinematicStep.eIRON_MAN_TEXT:
                textTime = Game.localization.getText("IDS_TXT_CINEMATIC_03").length * CINEMATIC_TIME_PER_LETTER;
                this._lblIntro3.setText("");
                this._imgIronManText.setVisible(true);
                this._lblIntro3.setVisible(true);
                this._imgNextText.setPosition(this._frameBtnNextIronMan.x, this._frameBtnNextIronMan.y);
                this._animationTween = this.createTween({ t: 0 })
                    .to({ t: 1 }, textTime)
                    .onUpdate((transition) => {
                        this._writeText(transition.t, Game.localization.getText("IDS_TXT_CINEMATIC_03"), this._lblIntro3);
                    })
                    .onComplete(() => {
                        this._readyForNextStep = true;
                        this._imgNextText.setVisible(true);
                    })
                    .start();
                break;
            case CinematicStep.eAVENGERS:
                Game.audio.playSfx("IDSND_CRT_CUT_IN_APPEAR");
                this._imgIronManText.setVisible(false);
                this._imgAvengers.setVisible(true);
                this._imgNextText.setVisible(false);
                let finalAvengersY = this._avengersY;
                this._imgAvengers.y = Game.screen.height / 2 + this._imgAvengers.height / 2;
                this._animationTween = this.createTween(this._imgAvengers)
                    .to({ y: finalAvengersY }, CINEMATIC_AVENGERS_APPEAR_TIME)
                    .easing(GameTween.Easing.ElasticOut)
                    .onComplete(() => {
                        ++this._introStep;
                        this._startstep();
                    })
                    .start();
                this._lokiFadeTween = this.createTween(this._imgLoki).to({ opacity: 0 }, CINEMATIC_PANEL_DISAPPEAR_TIME).start();
                this._ironManFadeTween = this.createTween(this._imgIronMan).to({ opacity: 0 }, CINEMATIC_PANEL_DISAPPEAR_TIME).start();
                break;
            case CinematicStep.eAVENGERS_TEXT:
                Game.audio.playSfx("IDSND_CINE_MESS_ASSEMBLE");
                this._imgAvengersText.setVisible(true);
                this._imgAvengersText.scale = 0.01;
                this._imgNextText.setPosition(this._frameBtnNextAvengers.x, this._frameBtnNextAvengers.y);
                this._animationTween = this.createTween(this._imgAvengersText)
                    .to({ scale: 1 }, CINEMATIC_AVENGERS_ASSEMBLE_APPEAR_TIME)
                    .easing(GameTween.Easing.ElasticOut)
                    .onComplete(() => {
                        ++this._introStep;
                        this._readyForNextStep = true;
                        this._imgNextText.setVisible(true);
                    })
                    .start();
                break;
        }
    }

    /**
     * Writes the text in the text box over time
     * @private
     * @param {Number} fraction
     * @param {String} text
     * @param {UiText} textBox
     */
    _writeText(fraction, text, textBox) {
        let textLength = Math.floor(text.length * fraction);

        if (fraction < 1) {
            textBox.setText(text.substring(0, textLength));
        } else {
            textBox.setText(text);
        }
    }

    /**
     * Destroys all tweens
     * @private
     */
    _destroyTweens() {
        if (this._animationTween) {
            this._animationTween.destroy;
            this._animationTween = null;
        }

        if (this._lokiFadeTween) {
            this._lokiFadeTween.destroy;
            this._lokiFadeTween = null;
        }

        if (this._ironManFadeTween) {
            this._ironManFadeTween.destroy;
            this._ironManFadeTween = null;
        }

        if (this._towerFadeTween) {
            this._towerFadeTween.destroy;
            this._towerFadeTween = null;
        }
    }
}
